import { render, staticRenderFns } from "./ReplayDMSButton.vue?vue&type=template&id=81af6be8&scoped=true"
import script from "./ReplayDMSButton.vue?vue&type=script&lang=js"
export * from "./ReplayDMSButton.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "81af6be8",
  null
  
)

export default component.exports